import { Component, ComponentFactoryResolver, ComponentRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DestroyableComponent } from '../../../../utils/destroyable.component';
import { ComponentConfiguration } from '../../models/component-config.model';
import { IColumnComponent } from '../../../custom-table/models/interfaces/column-component.interface';
import { PropertySearcher } from '../../helpers/property-searcher.helper';

@Component({
  selector: 'app-component-resolver',
  templateUrl: './component-resolver.component.html',
})
export class ComponentResolverComponent extends DestroyableComponent implements OnInit, OnDestroy {

  @Input() config: ComponentConfiguration;
  @Input() data?: unknown;

  @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
  componentRef: ComponentRef<IColumnComponent>;

  private toRecord(value: unknown): Record<string, unknown> {
    return (value && typeof value === 'object') ? value as Record<string, unknown> : {};
  }

  constructor(private resolver: ComponentFactoryResolver) {
    super();
  }

  ngOnInit() {
    this.container.clear();
    if (!this.data && !this.config.withoutData) { return; }
    const factory = this.resolver.resolveComponentFactory(this.config.componentType);
    this.componentRef = this.container.createComponent(factory);
    if (this.config.withoutData) { return; }

    if (this.config && this.config.withParseData) {
      const pairs = Object.entries(this.toRecord(this.data));
      pairs.forEach(pair => this.componentRef.instance[pair[0]] = pair[1]);
      return;
    }

    if (this.config && this.config.dataKey) {
      const inputParameters = PropertySearcher.findValue(this.data, this.config.dataKey);
      const pairs = Object.entries(this.toRecord(inputParameters));
      pairs.forEach(pair => this.componentRef.instance[pair[0]] = pair[1]);
      return;
    }

    this.componentRef.instance['data'] = this.data;
  }

  ngOnDestroy() {
    this.componentRef?.destroy();
  }

}
